/**
 * A function to open a website in a new tab
 * @param {string} website - The website you want to open
 */
export function openWebsiteLink(website: string): void {
  window.open(`https://${website}`, "_blank", "noopener");
}
